import {
  PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { getCurrencySymbol } from "../utils/functions";
import { useAuthContext } from "./auth.provider";

interface ICurrencyContext {
  currency?: string;
}

export const CurrencyContext = createContext<ICurrencyContext>({});

export const useCurrencyContext = () => useContext(CurrencyContext);

export default function CurrencyProvider({ children }: PropsWithChildren<{}>) {
  const { user } = useAuthContext();

  const [currency, setCurrency] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (user) {
      setCurrency(getCurrencySymbol(user.country_code));
    } else {
      setCurrency(getCurrencySymbol("USA"));
    }
  }, [user]);

  return (
    <CurrencyContext.Provider value={{ currency }}>
      {children}
    </CurrencyContext.Provider>
  );
}
